var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-bar'),_vm._v(" "),_c('div',{staticClass:"flex-1 container mx-auto p-8",attrs:{"id":"content"}},[_vm._t("default")],2),_vm._v(" "),_c('footer-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }